(() => {
  angular
    .module('app.campaign')
    .controller('DeleteTrackpointModalController', DeleteTrackpointModal);

  DeleteTrackpointModal.$inject = [
    '$element',
    'close',
    'currentCampaign',
    'selectedSourcesADH',
    'selectedTrackpoints',
  ];

  function DeleteTrackpointModal(
    $element,
    close,
    currentCampaign,
    selectedSourcesADH,
    selectedTrackpoints,
  ) {
    const vm = this;

    vm.selectedTrackpoints = selectedTrackpoints.length !== 0 ?
      selectedTrackpoints : selectedSourcesADH;

    vm.removeTrackpoints = () => {
      if (selectedTrackpoints.length !== 0) {
        angular.forEach(selectedTrackpoints, trackpoint => {
          currentCampaign.trackpoints.splice(_.indexOf(currentCampaign.trackpoints, trackpoint), 1);
        });
      }

      if (selectedSourcesADH.length !== 0) {
        angular.forEach(selectedSourcesADH, trackpoint => {
          currentCampaign.sources.splice(_.indexOf(currentCampaign.sources, trackpoint), 1);
        });
      }

      vm.close();
    }

    const removeBackdrop = () => $('.modal-backdrop').remove();

    vm.close = () => {
      removeBackdrop();

      $element.modal('hide');
      close(null, 500);
    };
  }
})();
